import InternalBookingCardBase from '../common/InternalBookingCardBase';
import { generateUniqueColor } from '../../../../util/colorUtil';
import { extractUpgradeSymbols } from '../../../../util/upgradeSymbolsHelper';

function BookingCardExitv2({
  booking,
  resourceColorById,
  updateBookingState,
  handleOpenModal,
  renderAvailableSlots,
  rowHeight,
  onBookingShift,
  entertainment,
  onDragStart,
  onDragActivated,
  onDragEnd,
  availableShiftTimes,
  isShiftable,
  isBookingReadyForShift,
  resourceStartOffsetMinutes = 0,
  openingGridOffset = 0,
}) {
  const rawResourceId = booking.resourceId?._id || booking.resourceId;
  const resourceIdStr = rawResourceId != null ? String(rawResourceId) : null;
  const pooledColor =
    resourceIdStr && resourceColorById instanceof Map ? resourceColorById.get(resourceIdStr) : null;
  const color = resourceIdStr ? pooledColor || generateUniqueColor(resourceIdStr) : '#ffffff';

  const upgradeSymbols = extractUpgradeSymbols(booking);

  const handleCardClick = (bookingId, color) => {
    handleOpenModal(bookingId, color);
  };

  return (
    <InternalBookingCardBase
      booking={booking}
      getParticipantCount={bk => bk.participantCount}
      onCardClick={handleCardClick}
      renderAvailableSlots={renderAvailableSlots}
      rowHeight={rowHeight}
      onBookingShift={onBookingShift}
      entertainment={entertainment}
      onDragStart={onDragStart}
      onDragActivated={onDragActivated}
      onDragEnd={onDragEnd}
      availableShiftTimes={availableShiftTimes}
      isShiftable={isShiftable}
      isBookingReadyForShift={isBookingReadyForShift}
      iconProps={{
        upgrades: upgradeSymbols,
        manualUpgrades: [],
        participantCount: booking.participantCount,
        slotMode: false,
        color,
      }}
      color={color}
      renderDuration={false}
      resourceStartOffsetMinutes={resourceStartOffsetMinutes}
      openingGridOffset={openingGridOffset}
    />
  );
}

export default BookingCardExitv2;
